(function() {

    var bulletFeaturesTemplate = '{{#each (item, idx) in bulletFeatures}}'+
                                        '<li><span>{{item.specName}}</span>{{item.specValueName}}</li>' +
                                 '{{/each}}';

    //BTOCSITE-77481 [웹앱 접근성 개선활동] aria-seleced 추가
    var popupImgListTemplate = '{{#each (item, idx) in galleryImages}}'+
                                    '{{#if item.contentType == "360"}}' +
                                        '<li class="pop-thumbnail view {{#if idx == 0}} active {{/if}}">\n' +
                                            '<a href="#none" aria-selected="{{#if idx == 0}} true {{#else}} false {{/if}}">\n' +
                                                '<span class="blind">{{item.productCode}}</span>\n' +
                                            '</a>\n' +
                                        '</li>\n' +
                                    '{{#elsif item.contentType == "video"}}'+
                                        '<li class="pop-thumbnail {{#if item.videoType == "YouTube"}} youtube {{#else}} video {{/if}} {{#if idx == 0}} active {{/if}}">\n' +
                                            '<a href="#none" aria-selected="{{#if idx == 0}} true {{#else}} false {{/if}}">\n' +
                                                '{{#if item.videoType == "YouTube"}}' +
                                                    '<span class="blind">{{item.videoDesc}}</span>\n'+
                                                '{{#else}}'+
                                                    '<img data-src="{{item.videoThumbnailImage}}" class="lazyload" alt="">\n'+
                                                '{{/if}}'+
                                            '</a>\n' +
                                        '</li>\n' +
                                    '{{#else}}'+
                                        '<li class="pop-thumbnail {{#if idx == 0}} active {{/if}}">\n' +
                                            '<a href="#none" aria-selected="{{#if idx == 0}} true {{#else}} false {{/if}}">\n' +
                                                '<img data-src="{{item.smallImageAddr}}" class="lazyload" alt="{{modelDisplayName}} 이미지 {{idx + 1}}번" onError="lgkorUI.addImgErrorEvent(this);">\n' +
                                            '</a>\n' +
                                        '</li>\n' +
                                    '{{/if}}'+
                                '{{/each}}';

    //BTOCSITE-77481 [웹앱 접근성 개선활동] aria-seleced 추가
    var pcImgListTemplate = '{{#each (item, idx) in galleryImages}}'+
                                '{{#if idx < 5}}'+
                                    '{{#if item.contentType == "360"}}' +
                                        '<li class="thumbnail view {{#if idx == 0}} active {{/if}}">\n'+
                                            '<a href="#none" data-link-area="product_summary-thumbnail" data-idx="{{idx}}" data-link-type="{{item.contentType}}" aria-selected="{{#if idx == 0}} true {{#else}} false {{/if}}">\n'+
                                                '<span class="blind">그램 360 360view</span>\n'+
                                                '<span class="blind">선택됨</span>\n'+
                                            '</a>\n'+
                                        '</li>\n'+
                                    '{{#elsif item.contentType == "video"}}'+
                                        '<li class="thumbnail {{#if item.videoType == "YouTube"}} youtube {{#else}} video {{/if}}  {{#if idx == 0}} active {{/if}}">\n'+
                                            '{{#if item.videoType == "YouTube"}}'+
                                                '<a href="#none" title="Open the video layer popup" data-link-area="product_summary-thumbnail" data-idx="{{idx}}" data-link-type="{{item.contentType}}" data-video-type="{{item.videoType}}" aria-selected="{{#if idx == 0}} true {{#else}} false {{/if}}">\n'+
                                                    '<span class="blind">{{item.videoDesc}}</span>\n'+
                                                '</a>\n'+
                                            '{{#else}}'+
                                                '<a href="#none" data-link-area="product_summary-thumbnail" data-idx="{{idx}}" data-link-type="{{item.contentType}}" data-video-type="{{item.videoType}}" aria-selected="{{#if idx == 0}} true {{#else}} false {{/if}}">\n'+
                                                    '<img data-src="{{item.videoThumbnailImage}}" class="lazyloaded" alt="{{modelDisplayName}} 이미지 {{idx + 1}}번" data-loaded="true">\n'+
                                                '</a>\n'+
                                            '{{/if}}'+
                                        '</li>\n'+
                                    '{{#else}}'+
                                        '<li class="thumbnail {{#if idx == 0}} active {{/if}}">\n' +
                                            '<a href="#none" data-link-area="product_summary-thumbnail" data-idx="{{idx}}" data-link-type="{{item.contentType}}" aria-selected="{{#if idx == 0}} true {{#else}} false {{/if}}">\n' +
                                                '<img data-src="{{item.smallImageAddr}}" class="lazyloaded" alt="{{modelDisplayName}} 이미지 {{idx + 1}}번" data-loaded="true" onError="lgkorUI.addImgErrorEvent(this);">\n' +
                                            '</a>\n' +
                                        '</li>' +
                                    '{{/if}}'+
                                '{{/if}}'+
                                '{{#if idx == 5}}'+
                                    '<li class="thumbnail more">\n' +
                                        '<a href="#none" data-link-area="product_summary-thumbnail" data-idx="{{idx}}" data-link-type="{{item.contentType}}" aria-selected="{{#if idx == 0}} true {{#else}} false {{/if}}">\n' +
                                            '<img data-src="{{item.smallImageAddr}}" class="lazyloaded" alt="{{modelDisplayName}} 이미지 {{idx + 1}}번" data-loaded="true" onError="lgkorUI.addImgErrorEvent(this);">\n' +
                                            '<span class="count">+{{galleryImages.length - 5}}</span>\n' +
                                        '</a>\n' +
                                    '</li>' +
                                '{{/if}}'+
                            '{{/each}}';

    var moImgListTemplate = '{{#each (item, idx) in galleryImages}}'+
                                '<li class="slide-conts ui_carousel_slide default {{#if item.videoType == "YouTube"}} video {{/if}}">\n' +
                                '{{#if item.contentType == "video"}}' + // video + youtube
                                    '{{#if item.videoType == "YouTube"}}'+ // youtube
                                        '<a href="#none" data-idx="{{idx + 1}}" title="비디오 창 열기" data-link-area="" data-link-name="YouTube">\n' +
                                            '<img data-lazy="{{item.videoThumbnailImage}}" class="lazyloaded" alt="{{item.videoDesc}}" data-loaded="true" style="opacity:0;">\n'+
                                        '</a>\n' +
                                    '{{#else}}'+  //mp4
                                        '<div class="gr-visual-animation">\n'+
                                            '<div class="image-cover">\n'+
                                                '<img src="{{item.videoThumbnailImage}}" alt="{{item.videoDesc}}">\n'+
                                            '</div>\n'+                                        
                                            '<video autoplay muted playsinline loop src="{{item.videoUrl}}">\n'+
                                                '<source src="{{item.videoUrl}}" type="video/mp4">\n'+
                                            '</video>\n'+
                                            '<div class="video-controller">\n'+
                                                '<button type="button" class="btn-pause is-active"><span class="blind">정지</span></button>\n'+
                                                '<button type="button" class="btn-play"><span class="blind">재생</span></button>\n'+
                                            '</div>\n'+
                                        '</div>\n'+
                                    '{{/if}}'+
                                '{{#else}}'+ // 360 + image
                                    '<a href="#none" data-idx="{{idx + 1}}">\n' +
                                        '<img class="img-mobile" src="{{item.largeImageAddr}}" alt="{{modelDisplayName}} 이미지 {{idx + 1}}번" onError="lgkorUI.addImgErrorEvent(this);">\n' +
                                    '</a>\n' +
                                '{{/if}}'+    
                                '</li>' +
                            '{{/each}}';

    var gramOptionListTemplate = '{{#each (item, idx) in optionList}}'+
                                    '<li>\n' +
                                        '<span class="rdo-wrap">\n' +
                                            '<input type="radio" id="rdo11-{{idx + 1}}" data-optionId={{item.optionId}} name="rdo11" data-visible-target=".visible-target1" {{#if item.optionId == lowestPriceOptionId}}checked{{/if}}>\n' +
                                            '<label for="rdo11-{{idx + 1}}">\n' +
                                                '<span class="label-con">{{item.optionName}}</span>\n' +
                                                '<span class="label-con">\n' +
                                                    '<span class="txt">판매처<strong>{{item.mallCount}}</strong></span>\n' +
                                                    '<span class="sum">{{vcui.comma(item.lowestPrice)}}<span>원</span></span>\n' +
                                                '</span>\n' +
                                            '</label>\n' +
                                        '</span>\n' +
                                    '</li>\n' +
                                '{{/each}}';

    var gramMallListTemplate = '{{#each (item, idx) in mallList}}'+
                                    '<li>\n' +
                                        '<a href="{{item.pcLinkUrl}}" {{#if item.mallCode != "0"}} target="_blank" title="새 창 열림" {{/if}}>\n' +
                                            '<em class="tit">{{item.mallName}}</em>\n' +
                                            '<div class="compare-gram-info">\n' +
                                                '<em class="key-desc">{{item.mallProductName}}</em>\n' +
                                            '</div>\n' +
                                            '<div class="price-info">\n' +
                                                '<span class="basic-price {{#if item.lowestPriceFlag === "Y"}} low-price {{/if}}">{{#if item.lowestPriceFlag === "Y"}}최저{{/if}} <em>{{vcui.comma(item.salePrice)}}</em>원</span>\n' +
                                                '<div class="bar-group">\n' +
                                                    '{{#if item.freeDeliveryFlag === "Y"}}<span>무료배송</span>{{/if}}\n' +
                                                    '{{#if item.benefitInfo}}<span>{{item.benefitInfo}}</span>{{/if}}\n' +
                                                '</div>\n' +
                                            '</div>\n' +
                                        '</a>\n' +
                                    '</li>\n' +
                                    // BTOCDITE-23446
                                    // '{{#if item.mallCode === "0"}}'+
                                        // '<li>\n' +
                                        //     '<a href="{{item.pcLinkUrl}}">\n' +
                                        //         '<em class="tit">LG 베스트샵</em>\n' +
                                        //         '<div class="compare-gram-info">\n' +
                                        //             '<em class="key-desc">{{item.mallProductName}}</em>\n' +
                                        //         '</div>\n' +
                                        //         '<div class="price-info">\n' +
                                        //             '<span class="shop-price">※ 베스트샵 가격정보는<br class="mo-br"> 매장에 문의해주세요.</span>\n' +
                                        //         '</div>\n' +
                                        //     '</a>\n' +
                                        // '</li>\n' +
                                    // '{{/if}}'+
                                '{{/each}}';

    var keyFeatureTemplate = '<h4 class="sub-center-tit">주요스펙</h4>\n' +
                                '{{#each (item, idx) in keyFeatures}}' +
                                    '{{#if idx % 3 == 0}}' +
                                        '<ul class="spec-list">\n' +
                                    '{{/if}}' +
                                        '<li><span>{{item.SPEC_NAME}}</span><em>{{vcui.string.unescapeHTML(item.SPEC_VALUE_NAME)}}</em></li>\n' +
                                        '{{#if (idx + 1) % 3 == 0 || (idx + 1) == keyFeatures.length }}' +
                                            '</ul>\n' +
                                        '{{/if}}' +
                                '{{/each}}';

    var specListTemplate = '{{#each (item, i) in techSpecs}}' +
                                '<h4 class="sub-center-tit">{{item.title}}</h4>\n' +
                                '{{#each (subItem, idx) in item.spec}}' + 
                                    '{{#if idx % 3 == 0}}' +
                                        '<ul class="spec-list">\n' +
                                    '{{/if}}' +
                                        '<li><span>{{subItem.name}}</span><em>{{subItem.value}}</em></li>\n' +
                                        '{{#if (idx + 1) % 3 == 0 || (idx + 1) == item.spec.length }}' +
                                            '</ul>\n' +
                                        '{{/if}}' +
                                '{{/each}}' +
                            '{{/each}}';


    var specMoreBtnTemplate = '<div class="btn-area">\n' +
                                 '<button type="button" class="btn border size-m btm-add"><span>스펙 자세히 보기</span></button>\n' +
                                 '<button type="button" class="btn border size-m btm-del" style="display:none"><span>닫기</span></button>\n' +
                               '</div>';

    // S : BTOCSITE-24797 [렛츠그램] VOC기반 CX고도화 과제
    var aiReviewInfoTemplate = '{{#if totalCount > 0}}' +
                                    '<div class="review-box">\n' +
                                        '<span class="tit">전체 리뷰 수</span>\n' +
                                        '<span class="count-num">{{vcui.comma(totalCount)}}</span>\n' +
                                        '{{#if newCount > 0}}' +
                                        '<span class="rank-num"><em>new</em>{{vcui.comma(newCount)}}</span>\n' +
                                        '{{/if}}' +
                                    '</div>\n' +
                                '{{/if}}' +
                                '{{#if positiveRate > 0}}' +
                                    '<div class="review-box">\n' +
                                        '<span class="tit">긍정 리뷰</span>\n' +
                                        '<span class="count-num up">{{positiveRate}}<em>%</em></span>\n' +
                                    '</div>\n' +
                                '{{/if}}';

    var aiReviewCountInfoTemplate = '<h3 class="re-tit">자주 언급하는 <em>{{aiReviewCount}}가지 요소 및 의견 한 줄 요약</em></h3>';

    var aiReviewListTemplate = '{{#each (item, i) in aiReviewList}}' +
                                    '{{#if item.exaoneReviewType == "01"}}' +
                                        '<li class="lists">\n' +
                                            '<div class="tit-box">\n' +
                                                '<span>{{item.attributeName}}</span>\n' +
                                                '{{#if item.reviewCount >= 10}}' +
                                                '<span class="count">{{vcui.comma(Math.round(item.reviewCount / 10) * 10)}}+</span>\n' +
                                                '{{/if}}' +
                                            '</div>\n' +
                                            '<div class="head">\n'+
                                                '<div class="acco-head">\n'+
                                                    '<span class="bar" style="width:{{(item.reviewCount / item.totalCount) * 100}}%;"></span>\n'+
                                                    '<span class="title">{{item.sentence}}</span>\n'+
                                                '</div>\n' +
                                                '<a href="#n" class="accord-btn ui_accord_toggle" data-open-text="내용 더 보기" data-close-text="내용 닫기" data-contents="AI 리뷰픽 / {{item.attributeName}}">\n' +
                                                    '<span class="blind ui_accord_text">내용 더 보기</span>\n'+
                                                '</a>\n' +
                                            '</div>\n' +
                                            '<div class="accord-cont ui_accord_content" style="display:none;">\n'+
                                                '<p>{{item.sentence}}</p>\n'+
                                            '</div>\n'+
                                        '</li>\n' +
                                    '{{/if}}' +
                               '{{/each}}';

    var aiNewReviewInfoTemplate = '{{#each (item, i) in aiReviewList}}' +
                                        '{{#if item.exaoneReviewType == "02"}}' +
                                            '<div class="review-line-box">\n'+
                                                '<div class="flag-wrap bg-type">\n'+
                                                    '<span class="flag colortypy03"><span class="blind"></span>{{item.attributeName}}</span>\n'+
                                                '</div>\n'+
                                                '<p class="tit">새로운 AI 리뷰픽</p>\n'+
                                                '<p class="desc">{{item.sentence}}</p>\n'+
                                            '</div>\n'+
                                        '{{/if}}' +
                                   '{{/each}}';
    // E : BTOCSITE-24797 [렛츠그램] VOC기반 CX고도화 과제

    var gramSearchPdp = {
        publUrl:{
            getGramSearchDetail : '/lg5-common/data-ajax/gram/gramComparePriceDetail.json'
          , getGramSearchMallList : '/lg5-common/data-ajax/gram/gramSearchPdpMallList'
          , getSpecDetail : '/lg5-common/data-ajax/gram/specDetailInfo.json'
        },
        url:{
            getGramSearchDetail : '/mkt/api/gram/retrieveGramComparePriceDetail.lgajax'
          , getGramSearchMallList : '/mkt/api/gram/retrieveGramOptionProduct.lgajax'
          , getSpecDetail : '/mkt/api/product/retrieveProductSpec.lgajax'
        },
        variable: {
            selectIdx: 0,
        },
        el: {
            $container: null                // 컨테이너
          , $pcThumnailImgList : null       // PC 썸네일 이미지 리스트
          , $pcMainImg : null               // PC 메인 이미지 
          , $moImgList : null               // MO 이미지 리스트
          , $modelDisplayName : null        // 디스플레이 모델 명
          , $modelName : null               // 모델명
          , $salePrice : null               // 판매가
          , $newProductBadgeFlag : null     // 신제품 플래그
          , $releaseDate : null             // 등록일
          , $mallName : null                // 판매처
          , $freeDeliveryFlag : null        // 무료배송 플래그
          , $purchaseBtn : null             // 구매하기 버튼
          , $mallCount : null               // 판매처 수
          , $optionList : null              // 옵션 리스트
          , $mallList : null                // 판매처 리스트
          , $bulletList : null              // 스펙 리스트
          , $reviewScore : null             // 리뷰평점
          , $reviewCount : null             // 리뷰수
          , $popupImgList : null            // 팝업 이미지 리스트
          , $popupMainImg : null            // 팝업 메인
          , $mallListMoreBtn : null         // 판매처 더보기 버튼
          , $specList : null                // 스펙 리스트
          , $specMoreBtn : null             // 스펙 더보기 버튼
          , $specCloseBtn : null            // 스펙 닫기 버튼
          , $modelNameCopy : null           // 모뎅명 클립보드 복사
          , $moBtn360 : null                // 360 버튼  
          , $popupZoomArea : null           // 갤러리뷰 줌 영역 
          , $popupVisual360 : null          // 갤러리뷰 360 노출 영역 
          , $popupVisualVideo : null        // 갤러리뷰 비디오 노출 영역       
          , $popupVisualImage : null        // 갤러리뷰 이미지 노출 영역
          , $view360 : null                 // 갤러리뷰 360 
          , $moSlider : null                // 모바일 슬라이더 영역
          , $pcMainVisual : null            // PC visual 영역 
          , $pinchZoom : null               // 갤러리뷰 핀치 줌 영역
          , $productSimpleInfo : null       // 앵커영역 디스플레이 모델 명
          //, $aiReviewInfo : null            // ai 리뷰 정보 : BTOCSITE-24797 [렛츠그램] VOC기반 CX고도화 과제
          //, $aiReviewList : null            // ai 리뷰 리스트 : BTOCSITE-24797 [렛츠그램] VOC기반 CX고도화 과제
          //, $aiNewReviewInfo : null         // ai NEW 리뷰 정보 : BTOCSITE-24797 [렛츠그램] VOC기반 CX고도화 과제
        },
        data: {
            modelId : ''
          , bulletFeatures : []
          , option : []
          , galleryImages : []
          , modelDisplayName: ''
          , salePrice : ''
          , mallName : ''
          , newProductBadgeFlag : ''
          , reviewCount: ''
          , reviewScore: ''
          , modelName: ''
          , modelReleaseDate: ''
          , freeDeliveryFlag: ''
          , mallList : []
          , baseOptionMallCount : 0
          , mallCount : 0
          , mallLink : ''
          , currentPage : 1
          , totalPage : 1
          , limit : 10
          , isDragging : false
          , lowestPriceOptionId : ''
          , isScrollDown : true       //setIsScrollDown() 통해 변경
          , lastScrollTop: 0
          //, aiReviewFlag : ''       //BTOCSITE-24797 [렛츠그램] VOC기반 CX고도화 과제
          //, aiReviewList : []       //BTOCSITE-24797 [렛츠그램] VOC기반 CX고도화 과제
          //, aiReviewCount : 0       //BTOCSITE-24797 [렛츠그램] VOC기반 CX고도화 과제
        },
        selector: {
            container : '.gram-search-detail'
          , pcThumnailImgList : 'ul.thumbnail-list'
          , pcActiveThumnail : '.thumbnail-list > li.active'
          , pcMainImg : 'div.gr-visual-image > a > img'
          , moImgList : 'ul.ui_carousel_track'
          , modelDisplayName : '.product-detail-info .prod-info .main'
          , newProductBadgeFlag : '.product-detail-info .prod-info .flag-wrap'
          , modelName : '.product-detail-info .prod-info .sku'
          , salePrice : '.product-detail-info .prod-info .price em'
          , releaseDate : '.product-detail-info .prod-info .date-info dd'
          , freeDeliveryFlag : '.product-detail-info .prod-info .sales-tag-wrap span.tag:eq(0)'
          , mallName : '.product-detail-info .prod-info .sales-tag-wrap span.tag:eq(1)'
          , purchaseBtn : '.product-detail-info .btn-info a'
          , optionList : 'ul.option-list'
          , mallList : 'ul.compare-list'
          , bulletFeatures : 'ul.spec-item'
          , mallCount : '#tab1 > .cont-wrap > .sub-center-tit > em'
          , reviewScore : '.product-detail-info .average-rating'
          , reviewCount : '.product-detail-info .review-count'
          , popupImgList : '.pop-thumbnail-list'
          , popupMainImg : '#modal_detail_target .item-box img'
          , mallListMoreBtn : '#mallListMoreBtn'
          , specList : '#tab2 .cont-wrap'
          , specMoreBtn : '#tab2 .cont-wrap div.btn-area .btm-add'
          , specCloseBtn : '#tab2 .cont-wrap div.btn-area .btm-del'
          , modelNameCopy : '.product-detail-info button.btn-copy'
          , moBtn360 : 'div.gr-ar-area'
          , popupZoomArea : '#imgGalleryPopup div.zoom-btn-area'
          , popupVisual360 : '#modal_detail_target div.view'
          , popupVisualVideo : '#modal_detail_target div.video'
          , popupVisualImage : '#modal_detail_target div.image'
          , view360 : '#view360'
          , moSlider : 'div.ui_carousel_slider'
          , pcMainVisual : 'div.pc-only div.gr-visual'
          , productSimpleInfo : 'div.product-simple-info .product-name'
          //, aiReviewInfo : 'div.ai-review div.review-info-box'      //BTOCSITE-24797 [렛츠그램] VOC기반 CX고도화 과제
          //, aiReviewList : '#aiReviewDetailList'                    //BTOCSITE-24797 [렛츠그램] VOC기반 CX고도화 과제
          //, aiNewReviewInfo : 'div.ai-review'                       //BTOCSITE-24797 [렛츠그램] VOC기반 CX고도화 과제
        },
        init: function() {
            this.data.modelId = $("#modelId").val();
            this.data.modelName = $("#modelName").val();
            
            this.getGramSearchDetail();
            this.el.$container = $(this.selector.container).first();
            this.el.$pcThumnailImgList = this.el.$container.find(this.selector.pcThumnailImgList);
            this.el.$pcMainImg = this.el.$container.find(this.selector.pcMainImg);
            this.el.$popupImgList = this.el.$container.find(this.selector.popupImgList);
            this.el.$popupMainImg = this.el.$container.find(this.selector.popupMainImg);
            this.el.$moImgList = this.el.$container.find(this.selector.moImgList);
            this.el.$newProductBadgeFlag = this.el.$container.find(this.selector.newProductBadgeFlag);
            this.el.$modelDisplayName = this.el.$container.find(this.selector.modelDisplayName);
            this.el.$modelName = this.el.$container.find(this.selector.modelName);
            this.el.$salePrice = this.el.$container.find(this.selector.salePrice);
            this.el.$releaseDate = this.el.$container.find(this.selector.releaseDate);
            this.el.$freeDeliveryFlag = this.el.$container.find(this.selector.freeDeliveryFlag);
            this.el.$mallName = this.el.$container.find(this.selector.mallName);
            this.el.$purchaseBtn = this.el.$container.find(this.selector.purchaseBtn);
            this.el.$optionList = this.el.$container.find(this.selector.optionList);
            this.el.$mallCount = this.el.$container.find(this.selector.mallCount);
            this.el.$mallList = this.el.$container.find(this.selector.mallList);
            this.el.$bulletList = this.el.$container.find(this.selector.bulletFeatures);
            this.el.$reviewScore = this.el.$container.find(this.selector.reviewScore);
            this.el.$reviewCount = this.el.$container.find(this.selector.reviewCount);
            this.el.$mallListMoreBtn = this.el.$container.find(this.selector.mallListMoreBtn);
            this.el.$specList = this.el.$container.find(this.selector.specList);
            this.el.$modelNameCopy = this.el.$container.find(this.selector.modelNameCopy);
            this.el.$moBtn360 = this.el.$container.find(this.selector.moBtn360);
            this.el.$popupZoomArea = this.el.$container.find(this.selector.popupZoomArea);
            this.el.$popupVisual360 = this.el.$container.find(this.selector.popupVisual360);
            this.el.$popupVisualVideo = this.el.$container.find(this.selector.popupVisualVideo);
            this.el.$popupVisualImage = this.el.$container.find(this.selector.popupVisualImage);
            this.el.$view360 = this.el.$container.find(this.selector.view360);
            this.el.$moSlider = this.el.$container.find(this.selector.moSlider);
            this.el.$pcMainVisual = this.el.$container.find(this.selector.pcMainVisual);         // BTOCSITE-67290
            this.el.$productSimpleInfo = this.el.$container.find(this.selector.productSimpleInfo);
           //this.el.$aiReviewInfo = this.el.$container.find(this.selector.aiReviewInfo);        //BTOCSITE-24797 [렛츠그램] VOC기반 CX고도화 과제
           //this.el.$aiReviewList = this.el.$container.find(this.selector.aiReviewList);        //BTOCSITE-24797 [렛츠그램] VOC기반 CX고도화 과제
           //this.el.$aiNewReviewInfo = this.el.$container.find(this.selector.aiNewReviewInfo);  //BTOCSITE-24797 [렛츠그램] VOC기반 CX고도화 과제
        },
        // 이벤트 바인딩
        bindEvent: function() {

            // PC 이미지 썸네일 클릭
            this.el.$pcThumnailImgList.find("a").on('click', function(e) {
                var index = gramSearchPdp.el.$pcThumnailImgList.find("a").index(this);
                gramSearchPdp.el.$pcThumnailImgList.find("li").removeClass("active");
                $(this).parent().addClass("active");

                // S : BTOCSITE-77481 [웹앱 접근성 개선활동] aria-seleced 추가
                gramSearchPdp.el.$pcThumnailImgList.find("li > a").attr("aria-selected","false")
                $(this).attr("aria-selected","true")
                // E : BTOCSITE-77481 [웹앱 접근성 개선활동] aria-seleced 추가

                // more, 360의 경우 바로 모달 띄움 
                if ($(this).parent().hasClass("more") || $(this).data("link-type") == "360") {
                    // modal open
                    gramSearchPdp.openVisualModal(index, this);
                } 
                gramSearchPdp.setPcMainVisual(index);
            });

            // PC 메인 이미지 클릭
            this.el.$pcMainImg.parent().on('click', function(e) {
                e.preventDefault();
                var index = $(gramSearchPdp.selector.pcActiveThumnail).index();
                gramSearchPdp.openVisualModal(index, this);
            });

            // MO 메인 이미지 클릭
            this.el.$moImgList.find("a").on('click', function(e) {
                e.preventDefault();
                var index = $(this).data("idx") - 1;
                gramSearchPdp.openVisualModal(index, this);
            });

            // 팝업 - 이미지 썸네일 클릭
            this.el.$popupImgList.find("a").on('click', function(e) {
                var index = gramSearchPdp.el.$popupImgList.find("a").index(this);
                gramSearchPdp.el.$popupImgList.find("li").removeClass("active");
                $(this).parent().addClass("active");
                gramSearchPdp.setModalVisual(index);

                // S : BTOCSITE-77481 [웹앱 접근성 개선활동] aria-seleced 추가
                gramSearchPdp.el.$popupImgList.find("li > a").attr("aria-selected","false")
                $(this).attr("aria-selected","true")
                // E : BTOCSITE-77481 [웹앱 접근성 개선활동] aria-seleced 추가
            });

            // 모델명 복사
            this.el.$modelNameCopy.on('click',function() {
                var tBtn = $(this)
                var txt = $(this).parent().find(".sku").text(); // E : BTOCSITE-77481 [웹앱 접근성 개선활동] 모델명 문구 복사 타겟 수정
                lgkorUI.confirm('모델명을 복사하시겠습니까?', {
                    title: "",
                    cancelBtnName: "취소",
                    okBtnName: "복사",
                    ok:function(){
                        vcui.dom.copyToClipboard(txt, {
                            container:this,
                            onSuccess: function () {
                                $(window).trigger("toastshow", "모델명을 복사했습니다.");
                            }
                        });
                    }
               },tBtn);
            });

            // option 클릭
            this.el.$optionList.find("li").on('change', function(e) {
                e.preventDefault();
                var optionId = $(this).find("input").data("optionid");

                //  페이지 초기화
                gramSearchPdp.data.currentPage = 1;
                // mall List 호출
                gramSearchPdp.getGramSearchMallList(optionId, "");
            });

            // 판매처 더보기 버튼 클릭
            this.el.$mallListMoreBtn.on('click', function(e) {
                var optionId = gramSearchPdp.getCurrentOptionId();
                gramSearchPdp.getGramSearchMallList(optionId, "add");
            });


            // 구매하기 버튼 클릭
            this.el.$purchaseBtn.on('click', function(e) {
                e.preventDefault();
                window.open(gramSearchPdp.data.mallLink);
            });

            // 스펙 더보기 버튼 클릭
            this.el.$specMoreBtn.on('click', function(e) {
                gramSearchPdp.el.$specList.find("h4:gt(0)").show();
                gramSearchPdp.el.$specList.find("ul:gt(0)").show();
                gramSearchPdp.el.$specCloseBtn.show();
                gramSearchPdp.el.$specMoreBtn.hide();

            });
            
            // 스펙 닫기 버튼 클릭
            this.el.$specCloseBtn.on('click', function(e) {
                gramSearchPdp.el.$specList.find("h4:gt(0)").hide();
                gramSearchPdp.el.$specList.find("ul:gt(0)").hide();
                gramSearchPdp.el.$specMoreBtn.show();
                gramSearchPdp.el.$specCloseBtn.hide();
            }); 
            
            // 별점 클릭시 리뷰탭 이동 처리
            $(".review-info > a").on('click', function(e) {
                e.preventDefault();
                $("#gramDetailTab li:eq(2)").find("a").click();
            });

            // 탭 클릭 : BTOCSITE-77481 [웹앱 접근성 개선활동] 키보드에서만 동작 하도록 수정
            $("#gramDetailTab li a").on('click', function(e) {
                e.preventDefault()

                //alert($(this).attr("href"))
                var id = $(this).attr("href");
                var orgUrl = function() {
                    if(window.location.href.indexOf("#") > -1) {
                        return window.location.href.split("#")[0]
                    } else {
                        return window.location.href
                    }
                }
                var parentWrap = $(this).closest('.ui_sticky');
                var moveUrl = orgUrl() + id

                window.location.href = moveUrl
                parentWrap.addClass('fixed');
                parentWrap.attr('style',' display: block; position: fixed; left: 0px; right: 0px; z-index: 90; top: 0px;');   
            })

            // 탭 클릭 : BTOCSITE-77481 [웹앱 접근성 개선활동] 마우스에서만 동작 하는 이벤트 추가(기존 스크롤 애니매이션 대응)
            $("#gramDetailTab li a").on('mousedown', function(e) {
                e.preventDefault()

                var id = $(this).attr("href");
                var parentWrap = $(this).closest('.ui_sticky');

                /*if (id === '#tab2') {
                    if ($("#spec_info_iframe").length == 0){
                        gramSearchPdp.setProductInfo();
                    }
                }*/

                /* var movtop = $(id).offset().top;
                if($(window).outerWidth() < 768) {
                    movtop = movtop - 100;
                } else {
                    movtop =  movtop - 77;
                    // if(id == '#tab4') {
                    //     movtop = $(id).offset().top - 100;
                    // }
                } */
         
                // <!--[BTOCSITE-57367] [전시] 리뷰 내재화(크레마 솔루션제거) 
                var movtop = Math.floor($(id).offset().top);

                var topNaviH = $('.gram-nav-wrap.mo-only').not(':hidden').outerHeight() || 0;
                var topDistance = parentWrap.outerHeight() + (parentWrap.is('.fixed') ? 0 : topNaviH);
                
                movtop -= topDistance;
                // [BTOCSITE-57367] [전시] 리뷰 내재화(크레마 솔루션제거) -->

                //aiReviewSize();
                $('html, body').stop().animate({scrollTop:movtop}, 200, function(){
                    parentWrap.addClass('fixed');
                    parentWrap.attr('style',' display: block; position: fixed; left: 0px; right: 0px; z-index: 90; top: 0px;');                    
                });

                return false;
            });

            // 스크롤 이벤트 - 탭선택
            window.addEventListener('scroll', function() {
                var scrollTop = $(window).scrollTop();

                gramSearchPdp.setIsScrollDown(gramSearchPdp.lastScrollTop, scrollTop)

                var bottomArr = gramSearchPdp.getStickyBottom();
                
                $('#gramDetailTab').each(function() {
                    var $this = $(this);
                    var uiSticky = $this.closest('.ui_sticky');
                    var marginTop = 0;

                    uiSticky.attr('data-bottom', bottomArr[bottomArr.length - 1]);
                    $(window).trigger('scroll.KRC0040')
                    if (uiSticky.hasClass('fixed')) {
                        marginTop = uiSticky.attr('data-bottom') - uiSticky.outerHeight();
                        if (gramSearchPdp.data.isScrollDown) {
                            uiSticky.removeClass('down').addClass('up');
                        } else {
                            uiSticky.removeClass('up').addClass('down');
                        }
                    } else {
                        uiSticky.removeClass('down up');
                    }
                });
                
                gramSearchPdp.lastScrollTop = scrollTop;
                
                /* var tab1OffsetTop = Math.floor($("#tab1").offset().top - 100);
                var tab2OffsetTop = Math.floor($("#tab2").offset().top - 100);
                var tab3OffsetTop = Math.floor($("#tab3").offset().top - 100);
                var tab4OffsetTop = 100000
                if($("#tab4").length > 0){
                    if($("#tab4").css('display') == 'none'){return;}
                    tab4OffsetTop = Math.floor($("#tab4").offset().top - 140);
                }
                
                $("#gramDetailTab li").removeClass("on");
                if (scrollTop >= tab1OffsetTop && scrollTop < tab2OffsetTop) {
                    $("#gramDetailTab li:eq(0)").addClass("on"); // 가격비교 탭 선택
                } else if (scrollTop >= tab2OffsetTop && scrollTop < tab3OffsetTop) {
                    $("#gramDetailTab li:eq(1)").addClass("on"); // 제품정보 탭 선택
                } else if (scrollTop >= tab3OffsetTop && scrollTop < tab4OffsetTop) {
                    $("#gramDetailTab li:eq(2)").addClass("on"); // 리뷰 탭 선택
                }else if (scrollTop >= tab4OffsetTop) {
                    $("#gramDetailTab li:eq(3)").addClass("on"); // ai 리뷰 탭 선택
                } else {
                    $("#gramDetailTab li:eq(0)").addClass("on"); // 가격비교 탭 선택
                } */

                // <!--[BTOCSITE-57367] [전시] 리뷰 내재화(크레마 솔루션제거) 
                gramSearchPdp.variable.selectIdx = 0;
                
                var $sticky = $('#gramDetailTab').closest('.ui_sticky');
                var topDistance = $sticky.outerHeight();
                $('.tab-contents').each(function (idx) {
                    if (Math.floor($(this).offset().top) - topDistance > scrollTop) return false;
                        
                    gramSearchPdp.variable.selectIdx = idx;
                });

                $("#gramDetailTab li").eq(gramSearchPdp.variable.selectIdx).addClass('on').siblings().removeClass("on");
                // [BTOCSITE-57367] [전시] 리뷰 내재화(크레마 솔루션제거) -->
            });
            $(window).trigger('scroll');


            // 모바일 360 버튼 클릭 
            this.el.$moBtn360.on('click', function(e) {
                gramSearchPdp.openVisualModal(0,this);
            });

            // S : BTOCSITE-24797 [렛츠그램] VOC기반 CX고도화 과제
            // 화면 리사이즈 > 리뷰 텍스트 영역 말줄임 체크
            /*
            var aiREviewChk = true;
            var aiReviewSize = function() {
                var aiReviewAcc = $('.ai-accordion .acco-head');
                var txtPd = 61;
                if($(window).outerWidth() < 768) {
                    txtPd = 41;
                }
                aiReviewAcc.each(function(i, v){
                    var width = $(this).innerWidth() - txtPd;
                    var titWidth = $(this).find('.title').innerWidth();
                    if(width >= titWidth) {
                        $(this).closest('.head').removeClass('on-accord');
                        $(this).closest('.head').replaceClass('btn_close', 'btn_open');                     
                        $(this).closest('.head').find('.accord-btn').attr('aria-expanded', false);
                        $(this).closest('.lists').removeClass('on');
                        $(this).closest('.lists').find('.accord-cont').css('display', 'none');
                    }else {
                        $(this).closest('.head').addClass('on-accord');  
                        if($(this).closest('.lists').index() == 0 && aiREviewChk == true) {
                            aiREviewChk = false;
                            $(this).closest('.head').addClass('btn_close');                        
                            $(this).closest('.head').find('.accord-btn').attr('aria-expanded', true);
                            $(this).closest('.lists').addClass('on');
                            $(this).closest('.lists').find('.accord-cont').css('display', 'block');
                        }
                    }
                });
            }
            aiReviewSize();
            window.addEventListener('resize', function() {
                aiReviewSize();
            });
             */
            // E : BTOCSITE-24797 [렛츠그램] VOC기반 CX고도화 과제    

        },
        setting: function() {
            
            this.el.$pcThumnailImgList.append(vcui.template(pcImgListTemplate, {galleryImages: this.data.galleryImages, modelDisplayName: this.data.modelDisplayName}));  // PC 하단 이미지 리스트
            this.el.$moImgList.append(vcui.template(moImgListTemplate, {galleryImages: this.data.galleryImages, modelDisplayName: this.data.modelDisplayName}));  // MO 이미지 리스트
            this.data.newProductBadgeFlag == 'Y' ? this.el.$newProductBadgeFlag.show() : this.el.$newProductBadgeFlag.hide()  // 신제품 플래그
            this.el.$modelDisplayName.html(this.data.modelDisplayNamePlusSpec);  // 모델 디스플레이 명
            this.el.$modelName.text(this.data.modelName);  // // 모델 명
            this.el.$salePrice.text(vcui.comma(this.data.salePrice));  // 판매가
            this.el.$releaseDate.text(vcui.date.format(this.data.modelReleaseDate, "yyyy.MM"));  // 등록일
            this.el.$reviewScore.append(this.data.reviewScore);  // 리뷰 별점
            //[BTOCSITE-57367][전시] 리뷰 내재화(크레마 솔루션제거)
            if(this.data.reviewCount > 9999){
                this.el.$reviewCount.append("(9999+)");  // 리뷰 수
            }else{
                this.el.$reviewCount.append("(" + vcui.number.addComma(vcui.number.parse(this.data.reviewCount)) + ")");  // 리뷰 수
            }
            this.data.freeDeliveryFlag == 'Y' ? this.el.$freeDeliveryFlag.show() : this.el.$freeDeliveryFlag.hide()  // 무료배송
            this.el.$mallName.text(this.data.mallName);  // 판매처명
            this.el.$mallCount.text(this.data.mallCount);  // 판매처 수
            this.el.$optionList.append(vcui.template(gramOptionListTemplate, {optionList: this.data.option, lowestPriceOptionId:this.data.lowestPriceOptionId}));  // option 리스트
            this.el.$bulletList.append(gramSearchPdp.convert( vcui.template(bulletFeaturesTemplate, {bulletFeatures: this.data.bulletFeatures})));  // 스펙 리스트
            this.el.$productSimpleInfo.text(this.data.modelDisplayName);  // 앵커영역 모델 디스플레이명

            void 0

            //S : BTOCSITE-24797 [렛츠그램] VOC기반 CX고도화 과제
            //S : BTOCSITE-42881 렛츠그램에 AI 리뷰픽 확대안(개선) 적용
//            if(this.data.aiReviewFlag == "Y"){
//                $("#aiReviewTab").show();
//                $("#tab4").show();
//
//                this.el.$aiReviewInfo.append(vcui.template(aiReviewInfoTemplate, {totalCount: vcui.number.parse(this.data.aiReviewList[0].totalCount), newCount: vcui.number.parse(this.data.aiReviewList[0].newCount), positiveRate: vcui.number.parse(this.data.aiReviewList[0].positiveRate)}));
//
//                if(vcui.number.parse(this.data.aiReviewList[0].newCount) > 0){
//                    this.el.$aiReviewInfo.addClass("newCount");
//                }
//
//                if (vcui.number.parse(this.data.aiReviewCount) > 0) {
//                    this.el.$aiReviewInfo.after(vcui.template(aiReviewCountInfoTemplate, {aiReviewCount: this.data.aiReviewCount}));
//                }
//
//                this.el.$aiReviewList.append(vcui.template(aiReviewListTemplate, {aiReviewList: this.data.aiReviewList}));
//                this.el.$aiNewReviewInfo.append(vcui.template(aiNewReviewInfoTemplate, {aiReviewList: this.data.aiReviewList}));
//            } else {
//                $("#aiReviewTab").hide();
 //               $("#tab4").hide();
//            }
            //E : BTOCSITE-42881 렛츠그램에 AI 리뷰픽 확대안(개선) 적용
            //E : BTOCSITE-24797 [렛츠그램] VOC기반 CX고도화 과제

            // 리뷰 미노출 처리
            if (vcui.number.parse(this.data.reviewCount) == 0) {
                this.el.$reviewScore.parent().hide();
            }

            // 팝업
            $("#popupTitle").text(this.data.modelDisplayName);
            this.el.$popupImgList.append(vcui.template(popupImgListTemplate, {galleryImages: this.data.galleryImages, modelDisplayName: this.data.modelDisplayName}));  // 팝업 이미지 리스트

            gramSearchPdp.setLazyLoding();
            gramSearchPdp.setSwipe();
            gramSearchPdp.setPinchZoom();
            gramSearchPdp.getSpecDetail();
            gramSearchPdp.getGramSearchMallList(this.data.lowestPriceOptionId);
            gramSearchPdp.setProductInfo();

            // 360버튼 노출 제어 BTOCSITE-19564
            this.el.$moBtn360.hide();
            if (this.data.galleryImages[0].contentType == "360") {
                this.el.$moBtn360.show();
                if(this.el.$view360.length) {
                    vcui.require([
                        '/lg5-common/front/360view/js/View360.js'
                    ], function () {
                        gramSearchPdp.open360(); 
                    });
                }
            }

            // S : BTOCSITE-77481 [웹앱 접근성 개선활동] HTML 수정으로 인한 수정
            // 모바일 슬라이더 
            this.el.$moSlider.find("div.slide-number strong.current").text(1);
            this.el.$moSlider.find("div.slide-number span.total").text(this.data.galleryImages.length);
            // E : BTOCSITE-77481 [웹앱 접근성 개선활동] HTML 수정으로 인한 수정

            // pc main list 
            gramSearchPdp.setPcMainVisual(0);
            // mobile 동영상 설정 
            gramSearchPdp.setMoMainVisual();
        },
        // lazyLoding
        setLazyLoding : function() {
            vcui.require([
                'ui/lazyLoaderSwitch',
                'ui/lazyLoader'
            ], function () {
                var $wrap = $('.wrap.gram-only'); // 기존 body 는 lg.common 공통에서 lazy 대상으로 사용중이므로 하위 마크업으로 대상을 낮춰 서로 충돌 없도록 // BTOCSITE-67290 그램 찾기에서 제품 상세 진입 시 이미지 미노출 건 
                $wrap.vcLazyLoaderSwitch();
                $wrap.vcLazyLoader();
            });
        },
        // 스와이프
        setSwipe: function() {
            // MO 이미지 리스트 스와이프
            vcui.require(['ui/carousel'], function () {
                gramSearchPdp.el.$moSlider.vcCarousel({
                    infinite: true,
                    autoplay: false,
                    pauseOnHover: false,
                    pauseOnFocus: false,
                    swipeToSlide: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    variableWidth: false,
                    prevArrow:'.btn-arrow.prev',
                    nextArrow:'.btn-arrow.next',
                    focusOnSelect: false,
                    focusOnChange: false,
                    dots: false,
                    buildDots: false,
                    cssEase: 'cubic-bezier(0.33, 1, 0.68, 1)',
                    speed: 150,
                    touchThreshold: 100
                })
                .on('carouselafterchange', function(e,target,index){
                    gramSearchPdp.el.$moSlider.find("div.slide-number strong").text(index + 1);
                });
            });
        },
        // 핀치줌
        setPinchZoom : function() {
             //핀치줌
             vcui.require(['ui/pinchZoom'], function (PinchZoom) {
                gramSearchPdp.el.$pinchZoom = new PinchZoom('.zoom-area');

                $('#imgGalleryPopup div.zoom-btn-area .zoom-plus').on('click', function(e){
                    e.preventDefault();
                    var zoom = gramSearchPdp.el.$pinchZoom.getZoomFactor();
                    if(Math.round(zoom) >= 4) zoom = 0;
                    gramSearchPdp.el.$pinchZoom.runZoom(zoom+1, true); 
                });

                $('#imgGalleryPopup div.zoom-btn-area .zoom-minus').on('click', function(e){
                    e.preventDefault();
                    var zoom = gramSearchPdp.el.$pinchZoom.getZoomFactor();
                    gramSearchPdp.el.$pinchZoom.runZoom(zoom-1, true); 
                });

                gramSearchPdp.el.$popupMainImg.mousedown(function() {
                    gramSearchPdp.data.isDragging = false;
                })
                .mousemove(function() {
                    gramSearchPdp.data.isDragging = true;
                 })
                .mouseup(function() {
                    var wasDragging = gramSearchPdp.data.isDragging;
                    gramSearchPdp.el.isDragging = false;
                    if (!wasDragging) {
                        $('#imgGalleryPopup div.zoom-btn-area .zoom-plus').trigger('click');
                    }
                });
            });
        },
        // PC 이미지 레이어 오픈
        openVisualModal: function(index, eventTarget) {
            // 선택된 index에 대해 팝업 설정 
            gramSearchPdp.setModalVisual(index);
            
            // 팝업 썸네일 이미지 선택 처리
            gramSearchPdp.el.$popupImgList.find("li").removeClass("active");
            gramSearchPdp.el.$popupImgList.find("li").eq(index).addClass("active");

            if(eventTarget) {
                $('#imgGalleryPopup').vcModal({opener: eventTarget});
            } else {
                $('#imgGalleryPopup').vcModal();
            }
        },
        // 현재 선택된 optionId 
        getCurrentOptionId : function() {
            return this.el.$optionList.find("input[type=radio]:checked").data("optionid");
        },
        
        // 태그 변환
        convert : function(str) {
            str = str.replace(/&amp;/g, '&');
            str = str.replace(/&lt;/g, '<');
            str = str.replace(/&gt;/g, '>');
            str = str.replace(/&quot;/g, '"');
            str = str .replace(/&#039;/g, "'");
            str = str .replace(/&reg;/g, "®");
            return str;
        },

        // 제품 정보 아이프레임 삽입
        setProductInfo : function() {
            var domain = location.origin;
            if (location.hostname === 'localhost' || location.href.indexOf('.html') > -1 ||  location.hostname.indexOf("branddev") > -1){
                domain = "https://wwwdev50.lge.co.kr";
            } else if (location.hostname.indexOf("brandstg") > -1) {
                domain = "https://wwwstg.lge.co.kr";
            } else {
                domain = "https://www.lge.co.kr";
            }
            var url = domain + "/notebook/" + gramSearchPdp.data.modelName.toLowerCase() + "?dpType=overView";
            //var url = domain + "/notebook/17zd90p-gx5lk?dpType=overView";
            
            var iframe = document.createElement("iframe");
            iframe.setAttribute("id","spec_info_iframe");
            iframe.setAttribute("name","spec_info_iframe");
            iframe.setAttribute("scrolling","no");
            iframe.style.width = "100%";
            iframe.style.height = "100vh";
            iframe.style.border = "none";
            iframe.src = url;
            $("#tab2 .visual-area").append(iframe);

            iFrameResize({
                             log:false
                           , autoResize:false
                           , resizeFrom:'parent'
                           , checkOrigin:false
                           , inPageLinks:true
                         }, '#spec_info_iframe');
            //[BTOCSITE-38396]그램찾기 iframe 제품정보 탭 오류 수정 
            var bojung = $('#gramDetailTab').closest('.ui_sticky').outerHeight();
            var stickyIframe = document.getElementById('spec_info_iframe').contentWindow;
            var contentsH;
            $(window).on('load',function(){
                //init
                stickyIframe.postMessage(['setChildSpec'], '*')
            });
            window.addEventListener('message', function(e) {
                if(e.data[0] == 'gramHeight'){
                    $('#spec_info_iframe').css('height',e.data[1]);
                    contentsH = e.data[1];
                }else if(e.data[0] == 'KRC0040_html'){
                    $('#spec_info_iframe').parent().prepend(e.data[1]);
                    setSpecTab();
                }else if( e.data[0] == 'scrollMove'){
                    $(window).scrollTop($('#spec_info_iframe').parent().offset().top + e.data[1] - bojung)
                }else if(e.data[0] == 'active'){
                    $('.product-info-more .info-tab').removeClass('active');
                    $('.product-info-more .info-tab').eq(e.data[1]).addClass('active');
                var text = $('.product-info-more .info-tab.active a').text()
                $('.component.KRC0040').find('.product-info-more .on-txt').text(text)
                }
            });
            function setSpecTab(){
                $('.component.KRC0040').wrap('<div>');
                var $compParent = $('.component.KRC0040').parent();
                $compParent.css('height',$('.component.KRC0040').height());
                var $comp = $('.component.KRC0040')
                var $specParent =  $('#spec_info_iframe').parent();
                $comp.attr('style','');
                $comp.find('.product-info-more .on-txt').on('click',function(){
                    $comp.find('.product-info-more').toggleClass('open')
                });
                $specParent.find('.info-tab a').on('click',function(){
                    stickyIframe.postMessage(['click', $(this).parent().index() , $(this).attr('href') ], '*');
                    $comp.find('.product-info-more').removeClass('open')
                });
                $(window).on('scroll scroll.KRC0040',function(e){
                    var uiSticky = $('#gramDetailTab').closest('.ui_sticky');
                    var bojung = !!uiSticky.attr('data-bottom') ? Number(uiSticky.attr('data-bottom')) : uiSticky.outerHeight();
                    if($specParent.offset().top - bojung < $(window).scrollTop()){
                        if($(window).scrollTop() > contentsH + $specParent.offset().top - bojung){
                            $comp.removeClass('fixed').css('top',0);
                            stickyIframe.postMessage(['specSticky',0,bojung], '*');
                            $comp.css('transition', '');
                        }else{
                            $comp.addClass('fixed').css('top',bojung);
                            var scrollTop = $(window).scrollTop() - ($specParent.offset().top - bojung);
                            stickyIframe.postMessage(['specSticky',scrollTop,bojung], '*');
                            $comp.css('transition', 'top 0.3s ease');
                        }
                    }else{
                        $comp.removeClass('fixed').css('top',0);
                        stickyIframe.postMessage(['specSticky',0,bojung], '*');
                        $comp.css('transition', '');
                    }
                }).on('resizestart',function(){
                    $('#spec_info_iframe').css('height','auto');
                }).on('resizeend',function(){
                    bojung = $('#gramDetailTab').closest('.ui_sticky').outerHeight();
                    $compParent.css('height','auto').css('height',$('.component.KRC0040').height());
                    $(window).trigger('scroll');
                }).trigger('resizeend');
            }
            ////[BTOCSITE-38396]그램찾기 iframe 제품정보 탭 오류 수정 
        },

        // 그램 찾기 상세 데이터 호출
        getGramSearchDetail : function() {
            // 옵션 1개, 판매처 1개
            var sendUrl = "";
            if (location.hostname === 'localhost' || location.href.indexOf('.html') > -1) {
                sendUrl = gramSearchPdp.publUrl.getGramSearchDetail;
            } else {
                sendUrl = gramSearchPdp.url.getGramSearchDetail;
            }

            var requestData = {
                modelId: this.data.modelId,
            }

            lgkorUI.showLoading();
            lgkorUI.requestAjaxData(sendUrl, requestData, function(result) {
                gramSearchPdp.data.galleryImages = result.data[0].galleryImages;
                gramSearchPdp.data.bulletFeatures = result.data[0].bulletFeatures;
                gramSearchPdp.data.option = result.data[0].option;
                gramSearchPdp.data.modelDisplayName = result.data[0].modelDisplayName;
                gramSearchPdp.data.modelDisplayNamePlusSpec = result.data[0].modelDisplayNamePlusSpec;
                gramSearchPdp.data.salePrice = result.data[0].salePrice;
                gramSearchPdp.data.mallName = result.data[0].mallName;
                gramSearchPdp.data.newProductBadgeFlag = result.data[0].newProductBadgeFlag;
                gramSearchPdp.data.reviewCount = result.data[0].reviewsCount;
                gramSearchPdp.data.reviewScore = result.data[0].reviewsScore;
                gramSearchPdp.data.modelName = result.data[0].modelName;
                gramSearchPdp.data.modelReleaseDate = result.data[0].modelReleaseDate;
                gramSearchPdp.data.freeDeliveryFlag = result.data[0].freeDeliveryFlag;
                gramSearchPdp.data.mallLink = result.data[0].mallLink;
                gramSearchPdp.data.mallCount = result.data[0].mallCount;
                gramSearchPdp.data.lowestPriceOptionId = result.data[0].lowestPriceOptionId ? result.data[0].lowestPriceOptionId : result.data[0].option[0].optionId;
                //gramSearchPdp.data.aiReviewFlag = result.data[0].aiReviewFlag;      //BTOCSITE-24797 [렛츠그램] VOC기반 CX고도화 과제
                //gramSearchPdp.data.aiReviewList = result.data[0].aiReviewList;      //BTOCSITE-24797 [렛츠그램] VOC기반 CX고도화 과제
                //gramSearchPdp.data.aiReviewCount = result.data[0].aiReviewCount;    //BTOCSITE-24797 [렛츠그램] VOC기반 CX고도화 과제

                // 옵션, 판매처가 한개일 경우 옵션영역 히든 처리
                if (gramSearchPdp.data.option.length == 1 
                    && gramSearchPdp.data.mallCount == 1) {
                        gramSearchPdp.el.$optionList.closest(".gray-full-box").hide();
                }

                gramSearchPdp.setting();
                lgkorUI.hideLoading();
            }, "POST", "json");
        },

        // 그램 판매처 리스트 데이터 호출
        getGramSearchMallList : function(optionId, type) {
            var requestData = {
                modelId: this.data.modelId,
                optionId : optionId,
                page : this.data.currentPage,
                limit : this.data.limit
            }
            
            var sendUrl = "";
            if (location.hostname === 'localhost' || location.href.indexOf('.html') > -1) {
                sendUrl = gramSearchPdp.publUrl.getGramSearchMallList +"_" + optionId + "_" + this.data.currentPage +".json";
            } else {
                sendUrl = gramSearchPdp.url.getGramSearchMallList;
            }

            lgkorUI.showLoading();
            lgkorUI.requestAjaxData(sendUrl, requestData, function(result) {
                gramSearchPdp.data.mallList = result.data[0].mallList;
                gramSearchPdp.data.mallCount = result.data[0].mallCount;
                gramSearchPdp.data.totalPage = result.data[0].pagination.totalCount;

                if (gramSearchPdp.data.currentPage < gramSearchPdp.data.totalPage) {
                    gramSearchPdp.data.currentPage++;
                    gramSearchPdp.el.$mallListMoreBtn.show();
                } else {
                    gramSearchPdp.el.$mallListMoreBtn.hide();
                }

                if (type === 'add') {
                    gramSearchPdp.el.$mallList.append(vcui.template(gramMallListTemplate, {mallList: gramSearchPdp.data.mallList}));
                } else {
                    gramSearchPdp.el.$mallList.html(vcui.template(gramMallListTemplate, {mallList: gramSearchPdp.data.mallList}));
                }
                lgkorUI.hideLoading();
            }, "POST", "json");
        },

        // 스펙 상세정보 조회
        getSpecDetail : function() {
            
            var sendUrl = "";
            if (location.hostname === 'localhost' || location.href.indexOf('.html') > -1) {
                sendUrl = gramSearchPdp.publUrl.getSpecDetail;
            } else {
                sendUrl = gramSearchPdp.url.getSpecDetail;
            }
            
            var requestData = {
                modelId: this.data.modelId
            }
            lgkorUI.showLoading();
            lgkorUI.requestAjaxDataPost(sendUrl, requestData, function(result){
                var innerHtml = "";
                if (!vcui.isEmpty(result.data[0].keyFeatures)) {
                    innerHtml += vcui.template(keyFeatureTemplate, {keyFeatures: result.data[0].keyFeatures});
                }
                innerHtml += vcui.template(specListTemplate, {techSpecs: result.data[0].techSpecs});
                gramSearchPdp.el.$specList.html( gramSearchPdp.convert(innerHtml) );
                gramSearchPdp.el.$specList.find("h4:gt(0)").hide();
                gramSearchPdp.el.$specList.find("ul:gt(0)").hide();
                
                // 스펙 더보기, 닫기 삽입
                gramSearchPdp.el.$specList.find("h4:eq(1)").before( specMoreBtnTemplate );
                gramSearchPdp.el.$specMoreBtn = gramSearchPdp.el.$container.find(gramSearchPdp.selector.specMoreBtn);
                gramSearchPdp.el.$specCloseBtn = gramSearchPdp.el.$container.find(gramSearchPdp.selector.specCloseBtn);
                gramSearchPdp.bindEvent();
                lgkorUI.hideLoading();
            });
        },
        // main visual 영역 노출 
        setPcMainVisual : function(index){
            var $pcMainImg = gramSearchPdp.el.$pcMainVisual.find('.gr-visual-image');
            var $pcMainVedio = gramSearchPdp.el.$pcMainVisual.find('.gr-visual-animation');
            var $pcMainYoutube = gramSearchPdp.el.$pcMainVisual.find('.gr-visual-video');
            var $selectThumnail = gramSearchPdp.el.$pcThumnailImgList.find("li:eq("+index+")");
            var galleryItem = gramSearchPdp.data.galleryImages[index];

            // 영상 링크 비워주기 
            $pcMainVedio.find('video').attr('src','');
            $pcMainVedio.find('source').attr('src','');
            $pcMainYoutube.find('iframe').attr('src','');

            var linkType = $($selectThumnail).data("link-type");
            if(linkType == 'video'){ 
                if($($selectThumnail).data("video-type") == "YouTube" ){ // YouTube
                    $pcMainYoutube.find('iframe').attr('src',galleryItem.videoUrl);
                    $pcMainYoutube.find('img').attr('src', galleryItem.videoThumbnailImage);
                    $pcMainYoutube.find('img').attr('alt', "");
                    $pcMainYoutube.find('.see-video').attr({
                        'data-src': galleryItem.videoUrl,
                        'data-link-name': galleryItem.videoDesc
                    });
                    // 전체 영역 비노출 처리  
                    gramSearchPdp.el.$pcMainVisual.find('[class*="gr-visual-"]').removeClass("is-active");
                    $pcMainYoutube.addClass("is-active"); 
                }else{ // mp4 
                    $pcMainVedio.find('img').attr('src', galleryItem.videoThumbnailImage);
                    $pcMainVedio.find('img').attr('alt', "");
                    $pcMainVedio.find('source').attr({
                        'src' : galleryItem.videoUrl,
                        'type' : 'video/' + galleryItem.videoType
                    });
                    $pcMainVedio.find('video').attr('src', galleryItem.videoUrl);
                    $pcMainVedio.find('video')[0].play();
                    // 동작 / 멈춤 버튼 
                    var $controller = gramSearchPdp.el.$pcMainVisual.find('.video-controller');
                    var $pause = $controller.find('.btn-pause');
                    var $play = $controller.find('.btn-play');
                    // 버튼 초기화 
                    $play.removeClass('is-active');
                    $pause.addClass('is-active');
                    // 버튼 이벤트 정의 
                    $pause.on('click', function () {
                        gramSearchPdp.el.$pcMainVisual.find('.gr-visual-animation video')[0].pause();
                        $(this).removeClass('is-active');
                        $play.addClass('is-active');
                    });

                    $play.on('click', function () {
                        gramSearchPdp.el.$pcMainVisual.find('.gr-visual-animation video')[0].play();
                        $(this).removeClass('is-active');
                        $pause.addClass('is-active');
                    });
                    // 전체 영역 비노출 처리  
                    gramSearchPdp.el.$pcMainVisual.find('[class*="gr-visual-"]').removeClass("is-active");
                    $pcMainVedio.addClass("is-active");
                }
            }else { // 비디오가 아닌 경우 image 노출 
                $pcMainImg.find('img').attr('src', galleryItem.largeImageAddr);
                if($selectThumnail.hasClass("view")) {
                    $pcMainImg.find('img').attr('alt', this.data.modelDisplayName+" 360도 이미지 자세히 보기");
                } else if($selectThumnail.hasClass("youtube")) {
                    $pcMainImg.find('img').attr('alt', this.data.modelDisplayName+" 유튜브 영상 보기");
                } else {
                    $pcMainImg.find('img').attr('alt', $selectThumnail.find("img").attr("alt")+" 이미지 자세히 보기");
                }
                // 전체 영역 비노출 처리  
                gramSearchPdp.el.$pcMainVisual.find('[class*="gr-visual-"]').removeClass("is-active");
                $pcMainImg.addClass("is-active");
            }
        },
        // 모바일 visual 영역 초기화 
        setMoMainVisual : function(){
            if(gramSearchPdp.el.$moImgList.length && gramSearchPdp.el.$moImgList.find('video')) {
                var $video = gramSearchPdp.el.$moImgList.find('video');
                var $controller = gramSearchPdp.el.$moImgList.find('.video-controller');
                var $pause = $controller.find('.btn-pause');
                var $play = $controller.find('.btn-play');

                $pause.on('click', function () {
                    $video[0].pause();
                    $(this).removeClass('is-active');
                    $play.addClass('is-active');
                });

                $play.on('click', function () {
                    $video[0].play();
                    $(this).removeClass('is-active');
                    $pause.addClass('is-active');
                });
            }
        },
        // modal visual 영역 노출 
        setModalVisual : function(index){
            var item = gramSearchPdp.data.galleryImages[index];
            var contentType = item.contentType;
            var $modalVideoBox = $("#modalVideoBox");
            var $modalYoutubeBox = $("#modalYoutubeBox");

            // 영상 url 처리 
            $modalVideoBox.find('video').attr('src','');
            $modalVideoBox.find('source').attr('src','');
            $modalYoutubeBox.find('iframe').attr('src','');

            if (contentType == "360") { // 360
                gramSearchPdp.el.$popupMainImg.attr("src", item.largeImageAddr);
                gramSearchPdp.open360Resize();
                gramSearchPdp.el.$popupVisual360.show();
                // 영상 영역 비노출 
                $modalVideoBox.hide();
                $modalYoutubeBox.hide();
                gramSearchPdp.el.$popupVisualVideo.hide();
                // 이미지 영역 숨김처리 
                gramSearchPdp.el.$popupZoomArea.hide();
                gramSearchPdp.el.$popupVisualImage.hide();
            } else if(contentType == "video"){ // video
                if(item.videoType == "VideoFile" ){ // mp4
                    $modalVideoBox.find('div.visual-area img').attr("src", item.videoThumbnailImage);
                    $modalVideoBox.find('div.subtitle').html(item.videoDesc);
                    $modalVideoBox.find('source').attr({
                        'src' : item.videoUrl,
                        'type' : 'video/' + item.videoType
                    });
                    $modalVideoBox.find('video').attr('src', item.videoUrl);
                    $modalVideoBox.find('div.video-area video')[0].play();
                    $modalVideoBox.find('.vid-control-wrap button').removeClass('btn-play');
                    $modalVideoBox.find('.vid-control-wrap button').addClass('btn-pause');
                    // 영상 음소거 토글 버튼 
                    $modalVideoBox.find('.vid-control-wrap a').off('click').on('click', function(){
                        if($(this).hasClass('btn-play-muted')) {
                            $("#modalVideoBox").find('.vid-control-wrap a').removeClass('btn-play-muted');
                            $("#modalVideoBox").find('.vid-control-wrap a').addClass('btn-play-sound');
                            $("#modalVideoBox").find('div.video-area video')[0].muted = true;
                        } else {
                            $("#modalVideoBox").find('.vid-control-wrap a').removeClass('btn-play-sound');
                            $("#modalVideoBox").find('.vid-control-wrap a').addClass('btn-play-muted');
                            $("#modalVideoBox").find('div.video-area video')[0].muted = false;
                        }
                    });
                    // 영상 재생/멈춤 버튼 
                    $modalVideoBox.find('.vid-control-wrap button').off('click').on('click', function(){
                        if($(this).hasClass('btn-play')) {
                            $("#modalVideoBox").find('.vid-control-wrap button').removeClass('btn-play');
                            $("#modalVideoBox").find('.vid-control-wrap button').addClass('btn-pause');
                            $("#modalVideoBox").find('div.video-area video')[0].play();
                        } else {
                            $("#modalVideoBox").find('.vid-control-wrap button').removeClass('btn-pause');
                            $("#modalVideoBox").find('.vid-control-wrap button').addClass('btn-play');
                            $("#modalVideoBox").find('div.video-area video')[0].pause();
                        }
                    });
                    $modalVideoBox.show();
                    $modalYoutubeBox.hide();
                }else{ // youtube
                    $modalYoutubeBox.find('div.thumnail img').attr("data-src", item.videoThumbnailImage);
                    $modalYoutubeBox.find('iframe').attr("src", item.videoUrl+ '?autoplay=0&mute=1');
                    $modalYoutubeBox.find('.see-video').attr({
                        'data-src': item.videoUrl,
                        'data-link-name': item.videoDesc
                    });
                    $modalYoutubeBox.show();
                    $modalVideoBox.hide();
                }
                gramSearchPdp.el.$popupVisualVideo.show();
                // 360 정지
                gramSearchPdp.open360Stop();
                gramSearchPdp.el.$popupVisual360.hide();
                // 이미지 영역 숨김처리 
                gramSearchPdp.el.$popupZoomArea.hide();
                gramSearchPdp.el.$popupVisualImage.hide();

            } else { // image
                // 팝업메인 이미지
                gramSearchPdp.el.$pinchZoom.runZoom(1, false);
                gramSearchPdp.el.$popupMainImg.attr("src", item.largeImageAddr);
                gramSearchPdp.el.$popupZoomArea.show();
                gramSearchPdp.el.$popupVisualImage.show();
                // 360 정지
                gramSearchPdp.open360Stop();
                gramSearchPdp.el.$popupVisual360.hide();
                // 영상 영역 비노출 
                $modalVideoBox.hide();
                $modalYoutubeBox.hide();
                gramSearchPdp.el.$popupVisualVideo.hide();
            }
        },
        open360: function() {
            var self = this;
            self.view = new View360();
            self.view.setConfig({
                width: gramSearchPdp.el.$view360.scrollWidth,
                height: gramSearchPdp.el.$view360.scrollHeight,
                columns: gramSearchPdp.data.galleryImages[0].rotateTotal,
                open_cols: gramSearchPdp.data.galleryImages[0].openTotal, 
                pathType: gramSearchPdp.data.galleryImages[0].pathType, 
            });
            self.view.setNavigationConfig({
                showOpen: gramSearchPdp.data.galleryImages[0].openTotal > 1 ? true:false,
                showTurnLeft: gramSearchPdp.data.galleryImages[0].openTotal > 1 ? true:false,
            });
            self.view.setImagesDirectory( gramSearchPdp.data.galleryImages[0].productPath + gramSearchPdp.data.galleryImages[0].productCode );
            self.view.start(gramSearchPdp.el.$view360[0]);
            gramSearchPdp.el.$view360.append('<span class="View360-text-info">※ 제품의 대표 색상 및 디자인에 대한 이해를 돕기 위한 예시 이미지입니다.<br>해당 모델 색상은 아래 버튼의 이미지컷을 참고하세요.</span>');
        },
        open360Stop: function() {
            var self = this;
            if(gramSearchPdp.el.$view360.length && self.view) {
                self.view.stopAutoRotate();
                self.view.lastCol = 0;
                self.view.latestImageIdx = 0;
                self.view.currentCol = 0;
                self.view.currentRow = 0;
                self.view.displayCurrentImage();
            }
        },
        open360Resize: function() {
            var self = this;
            if(gramSearchPdp.el.$view360.length) {
                var w = $('#imgGalleryPopup').width();
                var p = Number($('#imgGalleryPopup').find('.default').css('padding-left').replace('px','') * 2);
                var ww = (w > 450)? 540 : w - p , hh = (w > 450) ? 540 : w - p;
                gramSearchPdp.el.$view360.css({
                    'width':ww,
                    'height':hh
                })
                if ( !!self.view ) {
                    self.view.setConfig({
                        width:  ww,
                        height: hh
                    });
                };
                self.view.updateCanvasSize();
                self.view.displayCurrentImage();
            }
        },
        /**
         * isScrollDown 정의 함수
         * @param {number} from 현 y 위치
         * @param {number} to 목적 y 위치
         * @returns {array}
         */
        setIsScrollDown: function(from, to) {
            var pageDirection = (from !== to) ? vcui.math.getDirection({y: from}, {y: to}, 'vertical') : null;
            var isDown = (pageDirection) ? pageDirection === 'up' : null; // true | false | null
            

            if (isDown !== null) gramSearchPdp.data.isScrollDown = isDown;
        },
        /**
         * 스티키 요소들 bottom값 배열로 반환
         * @param {string} id #포함한 id - 특정 위치로 이동했을 때의 bottom값 받기 위해 필요
         * @returns {array}
         */
        getStickyBottom: function(id) {
            var isMobile = window.innerWidth < 768;
            var $gramWrap = $('.gram-only');
            var $gramTab = $gramWrap.find('.logo-tab-wrap');
            var $gramDetailTab = $gramWrap.find('#gramDetailTab');
            var gramDetailTabH = $gramDetailTab.outerHeight() || 0;
            var headerH = isMobile ? $gramWrap.find('.header').outerHeight() : 0
            
            var bottomArr = [];

            // 헤더
            bottomArr.push(!gramSearchPdp.data.isScrollDown ? headerH : 0); // !isScrollDown - 화면 위로 올릴 때 header 높이 필요
            
            // 렛츠그램 개선 탭메뉴
            if (!!$gramTab.length) bottomArr.push(bottomArr[bottomArr.length - 1] + $gramTab.outerHeight());

            // 탭메뉴 (#gramDetailTab)
            if (!!$gramDetailTab.length) bottomArr.push(bottomArr[bottomArr.length - 1] + gramDetailTabH);
            
            return bottomArr;
        }

    };
    
    $(document).ready(function() {
        gramSearchPdp.init();
    });

    $(window).load(function(){
        if (typeof crema !== 'undefined') crema.init("", "");
    });
})();


(function() {
    var KRP0012 = {
        init: function() {
            var self = this;
            //크레마
            lgkorUI.cremaLogin();

            var $section = $('.KRP0012');
            var $contWrap = $section.find('.review-wrap');
            $contWrap.empty();

            var isMobile = vcui.detect.isMobile;
            var productcode = $section.data('productCode');
            //var widgetId = $section.data('widgetId');

            if(productcode) {
                //아이콘 위젯
                if(isMobile){
                    $contWrap.append('<style>.crema_statistics_widget > iframe[src^="[http://review-api9.cre.ma/]http://review-api9.cre.ma";] { display: none !important; }</style>' +
                        '<div class="crema-product-reviews crema_statistics_widget" data-product-code="' + productcode +'" data-widget-id="' + "110" + '" data-widget-style="statistics"></div>');
                } else {
                    $contWrap.append('<style>.crema_statistics_widget > iframe[src^="[http://review-api9.cre.ma/]http://review-api9.cre.ma";] { display: none !important; }</style>' +
                        '<div class="crema-product-reviews crema_statistics_widget" data-product-code="' + productcode +'" data-widget-id="' + "109" + '" data-widget-style="statistics"></div>');
                }

                //상품 리뷰 위젯
                if(isMobile){
                    $contWrap.append('<style>.crema-product-reviews > iframe { max-width: 100% !important; }</style><div class="crema-product-reviews" data-widget-id="' + "26" + '" data-product-code="' + productcode + '"></div>');
                } else {
                    $contWrap.append('<div class="crema-product-reviews KRP0012-crema-review" data-product-code="' + productcode + '"></div>');
                }

                //상품 소셜 위젯
                if(isMobile){
                    $contWrap.append('<style>.crema-product-reviews > iframe { max-width: 100% !important; }</style><div class="crema-product-reviews" data-product-code="' + productcode + '" data-widget-id="' + "40" + '"></div>');
                } else {
                    $contWrap.append('<div class="crema-product-reviews" data-product-code="' + productcode + '" data-widget-id="' + "39" + '"></div>');
                }
            }

            /*
            if(productcode && widgetId) {
                $contWrap.append('<div class="crema-product-reviews" data-product-code="' + productcode + '" data-widget-id="' + widgetId + '"></div>');
            }
            */
            setTimeout(self.reviewWrite, 1500); // BTOCSITE-8083

            //s: BTOCSITE-39526 - AI리뷰픽 확대 1차(일반 PDP적용)
            self.fnAiReview();
            //e: BTOCSITE-39526 - AI리뷰픽 확대 1차(일반 PDP적용)
            self.aiReviewAcc();
            //e: BTOCSITE-46610 - AI 리뷰픽 영역 문구 추가
            self.aiReviewTooltipToggle();
            self.aiReviewTooltipOff1();
            self.aiReviewTooltipOff2();
            
        },
        // S : BTOCSITE-8083
        reviewWrite: function() {
            var $section = $('.KRP0012');
            var ajaxUrl = '/mkt/api/product/retrieveProductRegisterInfo';
            if(location.pathname == '/html/components/KRP0012.html') ajaxUrl = '/lg5-common/data-ajax/pdp/pdp_status.json';
            var options = {
                isMobile: vcui.detect.isMobile,
                loginFlag : digitalData.hasOwnProperty("userInfo") && digitalData.userInfo.unifyId ? true : false,
                productcode : $section.data('productCode'),
                isProduct: true,
                ownStatus: false,
                orderStatus: false,
                cremaReviewTemplate: '<div class="review-write-wrap">'+
                /*
                '{{#if isProduct}}<div class="txt-area">'+
                '<p>보유 제품 등록하고 제품 리뷰 작성하면 최대 <strong>3,000P</strong>의 멤버십 포인트를 드립니다.</p>'+
                '</div>{{/if}}'+
                 */
                '<button type="button" class="{{#if orderStatus}}crema-new-review-link{{/if}} btn" data-product-code="{{productcode}}" data-own-status="{{ownStatus}}" {{#if isMobile}}data-review-source="mobile_my_orders"{{/if}}>상품 리뷰 작성하기</button>'+
                '</div>'
            };
            var sendata = {
                modelName: options.productcode,
                modelId: $("#modelId").val(),
                unifyId: (digitalData.userInfo)? digitalData.userInfo.unifyId:null,
            };
            var chkIE = false;
            var mutationObserver = new MutationObserver(function(entries) {
                entries.forEach(function(entry){
                    var id = crema.popup !== undefined ? crema.popup.iframe_id:'crema-review-popup';
                    if(vcui.detect.isIE) {
                        if($(entry.target).is('#'+id)) {
                            chkIE = true;
                        }
                        if(chkIE && !$('#'+id).is(':visible')) {
                            chkIE = false;
                            // console.log(crema.iframe_manager.iframes)
                            $('.KRP0012-crema-review').find('iframe').attr('src', $('.KRP0012-crema-review').find('iframe').attr('src'))
                        }
                    }else {
                        if(entry.removedNodes.length > 0) {
                            $(entry.removedNodes).each(function() {
                                if($(this).is('#'+id)) {
                                    // console.log('remove', crema)
                                    crema.message_handler.reload_all(crema.iframe_manager.iframes);
                                }
                            })
                        }
                    }
				});
            }); 
            lgkorUI.requestAjaxData(ajaxUrl, sendata, function(result) {
                var data = result.data[0];
                var appendTarget = $section.find('.accordion-custom-outter').size()>0 ? $section.find('.accordion-custom-outter'): $section.find('.review-wrap');
                options.orderStatus = (options.loginFlag && lgkorUI.stringToBool(data.isregistered)) ? true:false;
                options.ownStatus = lgkorUI.stringToBool(data.isregistered);
                options.isProduct = lgkorUI.stringToBool(data.isproduct);

                if(options.isProduct){
                    $("#aiReviewMsg").html('보유 제품 등록하고 제품 리뷰 작성하면 최대 <strong>3,000P</strong>의 멤버십 포인트를 드립니다.');
                }else{
                    $("#aiReviewMsg").remove();
                }

                appendTarget.before(vcui.template(options.cremaReviewTemplate, options));
                lgkorUI.cremaReload();

                mutationObserver.observe($('body')[0], { attributes: true, childList: true, subtree: true });
            },"POST", null, null, null, null, function(request){
                var err = (request == undefined) ? 'undefined' : request.status;
                void 0;
                // $section.find('.review-info-text').before(vcui.template(options.cremaReviewTemplate, options));
            });
            var flag = false;
            $section.off("click").on('click','.review-write-wrap .btn', function(e) {
                if(!flag) {
                    flag = true;
                    var msg = options.loginFlag ? '보유제품 등록 후 리뷰 등록 가능합니다':'리뷰 작성을 위해 로그인을 해주세요.';
                    var opt = {
                        typeClass: options.loginFlag ? 'crema-review-confirm':'',
                        okBtnName: options.loginFlag ? '보유제품 등록하기':'예',
                        cancel: function(){
                            flag = false;
                        },
                        ok: function(){
                            var link =  options.loginFlag ? '/my-page/manage-products?tab=1': '/sso/member/login';
                            location.href = link;
                        }
                    };
                    if(!lgkorUI.stringToBool($(this).attr('data-own-status'))) {
                        lgkorUI.confirm(msg, opt);
                    }
                }
                return false;
            });
        },
        // E : BTOCSITE-8083
        fnAiReview : function (){
            var aiParam = {
                modelId: $("#modelId").val(),
            };

            lgkorUI.requestAjaxData('/mkt/api/product/retrieveAiReviewInfo',aiParam ,function(result) {
                //console.log('result Data : ___________________________', result.data[0]);
                var aiReviewList = result.data[0].aiReviewList;
                var aiReviewCount = result.data[0].aiReviewCount;
                var totalCnt = 0;

                if(aiReviewList !=null && aiReviewList.length > 0){
                    totalCnt = result.data[0].aiReviewList[0].totalCount;
                }

                var _html = "";

                if (aiReviewCount != null && aiReviewCount > 1) {
                    _html += '<div class="review-ai-content-inner" >';
                    _html += '  <div class="review-ai-content-title">';
//                    _html += '      <div class="review-ai-title">';
//                    _html += '       	AI가 PICK한 <br> <em>' + totalCnt + '명</em>의 사용자 리뷰';
//                    _html += '      	<div class="tooltip-pdp-cont">';
//                    _html += '      		<button class="tooltip-pdp">AI 리뷰픽 설명</button>';
//                    _html += '      		<div class="tooltip-box-outter">';
//                    _html += '      			<div class="tooltip-box">';
//                    _html += '      				<strong class="title">AI 리뷰 PICK</strong>';
//                    _html += '      				<span class="text">외부쇼핑몰/LGE.COM에서 수집한 사용자 리뷰를 AI로 요약/생성한 것입니다</span>';
//                    _html += '      			</div>';
//                    _html += '      			<button class="btn-close">툴팁 닫기</button>';
//                    _html += '  			</div>';
//                    _html += '  		</div>';
//                    _html += '  	</div>';
//                    _html += '  	<span>자주 언급하는 의견 한줄 요약</span>';
                    _html += '  	<strong>여러 사이트에 흩어져 있는 리뷰를<br> <em>한눈에 볼 수 있게</em> 요약해 봤어요.</strong>';
                    _html += '  	<span>AI가 PICK한 '+ totalCnt +'명의 리뷰입니다.</span>';
                    _html += '  </div>';
                    _html += '  <div class="review-ai-content-subtitle">';
                    _html += '      <ul>';
                    for (var i = 0; i < aiReviewList.length; i++) { // loop start
                        _html += '        <li>';
                        _html += '            <span>' + aiReviewList[i].attributeName + '</span>';
                        _html += '            <em>' + aiReviewList[i].sentence + '</em>';
                        _html += '        </li>';
                    }
                    _html += '      </ul>';
                    _html += '  </div>';
                    _html += '</div>';
                    
                    $("#reviewAiContentArea").append(_html);
               }

            },"POST" ,"json");
        },
        aiReviewAcc: function() {
            setTimeout(function() {
                var targ = $('.review-info-text.custom1');
                var bt1 = $('.titleBt').outerHeight(true);
                function accoClose() {
                    var cont1 = $('.accordion-custom-outter .bullet-list .b-txt:first-child').outerHeight(true);
                    var padding = parseInt($('.review-info-text').css('padding-top')) + parseInt($('.review-info-text').css('padding-bottom'));
                    var math1 = bt1 + cont1 + padding;
                    targ.css('height', math1);
                }
                function accoOpen() {
                    var math1;
                    var cont1 = $('.accordion-custom-outter .bullet-list').outerHeight(true);
                    var padding = parseInt($('.review-info-text').css('padding-top')) + parseInt($('.review-info-text').css('padding-bottom'));
                    var mobH = targ.find('.titleBt').outerHeight() + targ.find('.bullet-list').outerHeight();
                    if($(window).width() < 769) {
                        math1 = mobH + padding;
                    } else {
                        math1 = bt1 + cont1 + padding;
                    }
                    targ.css('height', math1);
                }
                accoClose();
                aiReviewAccodion();
                $(window).resize(function() {
                    aiReviewAccodion();
                    if(targ.hasClass('active')) {
                        accoOpen();
                    } else {
                        accoClose();
                    }
                });

                function aiReviewAccodion() {
                    $('.titleBt').on('click', function(){
                        if(targ.hasClass('active')){
                            targ.removeClass('active');
                            accoClose();
                        } else {
                            targ.addClass('active');
                            accoOpen();
                        }
                    });
                }
            }, 500);
        },
        /* BTOCSITE-46610 [퍼블리싱] AI 리뷰픽 영역 문구 추가 start */
        aiReviewTooltipToggle: function() {
            setTimeout(function() {
                function pdpTooltipToggle() {
                    $(document).on('click', '.tooltip-pdp', function(){
                        var target1 = $(this).next(".tooltip-box-outter");
                        if (target1.hasClass('active')){
                            target1.removeClass("active");
                            void 0;
                        }
                        else {
                            target1.addClass("active");
                            void 0;
                        }
                    });
                }
                pdpTooltipToggle();
                void 0;
            }, 500)
        },
        aiReviewTooltipOff1: function() {
            setTimeout(function() {
                function pdpTooltipOff1() {
                    $(document).on('click', '.tooltip-box-outter .btn-close', function(){
                        var target2 = $(this).parent(".tooltip-box-outter");
                        if (target2.hasClass('active')){
                            target2.removeClass("active");
                            void 0;
                        }
                    });
                }
                pdpTooltipOff1();
                void 0;
            }, 500)
        },
        aiReviewTooltipOff2: function() {
            setTimeout(function() {
                function pdpTooltipOff2() {
                    $(document).on('mouseup', function (e){
                        if ($(".tooltip-box-outter").hasClass('active')){
                            if($(".tooltip-box-outter").has(e.target).length==0) {
                                $(".tooltip-box-outter").removeClass('active');
                                void 0;
                            }
                        }
                    });
                }
                pdpTooltipOff2();
                void 0;
            }, 500)
        }
        /* BTOCSITE-46610 [퍼블리싱] AI 리뷰픽 영역 문구 추가 end */
    }

    var loadReview = function() {
        var modelId = $("#modelId").val();
        var param = {
            b2cYN : lgkorUI.getHiddenInputData().b2cYN,
        };
        $.ajax({
            url: "/mkt/review/"+modelId+"/pdpReviewList",
            type: "GET",
            data: param,
            cache : false,
            contentType : 'application/x-www-form-urlencoded; charset=UTF-8;',
            success: function(data) {
                $('.KRP0012').find('.component-inner').html(data);
            },
            error: function(e) {
                void 0;
            }
        });
    }

    $(document).ready(function(){
        if(!document.querySelector('.KRP0012')) return false;
        //$('.KRP0012').buildCommonUI();
        //KRP0012.init();

        //[BTOCSITE-57367] 리뷰 내재화 (크레마 솔루션제거)
        loadReview();
    });
})();